export function isBetween(
  date: Date,
  period: {
    start: Date
    end: Date
  },
): boolean {
  const { end, start } = period
  return date.valueOf() >= start.valueOf() && date.valueOf() <= end.valueOf()
}
